import React from 'react';
import PrintIcon from '@mui/icons-material/Print';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@mui/material';

import { StyledEditorToolbar } from './styles';
import { fMonthDayTimeYear } from '../../utils/formatTime';
import Iconify from '../iconify';
import { PopoutAddEmoji } from "./PopoutAddEmoji";

const HEADINGS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6'];

export const formats = [
  'emoji',
  'align',
  'background',
  'blockquote',
  'bold',
  'bullet',
  'code',
  'code-block',
  'color',
  'direction',
  'font',
  'formula',
  'header',
  'image',
  'indent',
  'italic',
  'link',
  'list',
  'script',
  'size',
  'strike',
  'table',
  'underline',
  'video',
  'mention',
  'replyPreview'
];

EditorToolbar.propTypes = {
  id: PropTypes.string,
  isSimple: PropTypes.bool,
  noFormat: PropTypes.bool,
  removeHyperLink: PropTypes.bool,
  openDropzone: PropTypes.func,
  setOpenCustomLinkSetter: PropTypes.func,
  attachFile: PropTypes.bool,
  printChat: PropTypes.bool,
  verySimple: PropTypes.bool,
  chatBoxEditor: PropTypes.bool,
  quillRef: PropTypes.object,
  ticketMessages: PropTypes.array,
};

export default function EditorToolbar({
  id,
  noFormat,
  isSimple,
  verySimple,
  removeHyperLink,
  quillRef,
  printChat = false,
  attachFile = false,
  openDropzone = () => null,
  setOpenCustomLinkSetter = () => null,
  ticketMessages,
  chatBoxEditor = false,
  ...other
}) {

    const toolbarButtonStyle = {
      height: '16px',
      width: '16px',
      margin: '4px'
    }

  const handleDownloadTranscript = () => {
    if (!ticketMessages || ticketMessages.length === 0) {
      alert('No messages available to download.');
      return;
    }

    const stripHtmlTags = (html) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    };

    const transcript = ticketMessages.map((message) => {
      const user = message?.fullName || 'Unknown User';
      const timestamp = fMonthDayTimeYear(message.sentOn);
      const content = stripHtmlTags(message.note || '[Attachment]');
      return `
        <div style="margin-bottom:16px;">
          <hr>
          <strong>User:</strong> ${user}<br>
          <strong>Time:</strong> ${timestamp}<br>
          <strong>Message:</strong><br>
          <div style="white-space:pre-wrap;">${content}</div>
        </div>
      `;
    });

    const htmlContent = `
      <html>
        <head>
          <title>Ticket Transcript</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 40px; }
            h2 { margin-bottom: 0; }
            hr { border: none; border-top: 1px solid #ccc; }
          </style>
        </head>
        <body>
          <h2>Ticket Transcript</h2>
          <hr>
          ${transcript.join('')}
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  if (noFormat) {
    return (
      <StyledEditorToolbar {...other}>
        <div id={id} />
      </StyledEditorToolbar>
    );
  }
  if (verySimple) {
      return (
        <StyledEditorToolbar {...other}>
          <div id={id}>
            {' '}
            <div className="ql-formats">
              <Tooltip title="Bold">
                <button type="button" className="ql-bold" style={toolbarButtonStyle} />
              </Tooltip>
              <Tooltip title="Italic">
                <button type="button" className="ql-italic" style={toolbarButtonStyle} />
              </Tooltip>
              <Tooltip title="Underline">
                <button type="button" className="ql-underline" style={toolbarButtonStyle} />
              </Tooltip>
              <Tooltip title="Strikethrough">
                <button type="button" className="ql-strike" style={toolbarButtonStyle} />
              </Tooltip>
              <Tooltip title="Link">
                <IconButton sx={{ p: 0, m: 0, ":focus": { color: "rgb(33, 43, 54) !important" } }} disableFocusRipple disableRipple onClick={() => setOpenCustomLinkSetter(val => !val)}>    
                  <Iconify icon={"mingcute:link-fill"} style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }} />
                </IconButton>
              </Tooltip>
            </div>
            {/* <div className="ql-formats">
              {<button type="button" className="ql-list" value="ordered" style={toolbarButtonStyle} />}
              {<button type="button" className="ql-list" value="bullet" style={toolbarButtonStyle} />}
            </div> */}
            <div className="ql-formats">
              <Tooltip title="Attach File">
                <button type="button" onClick={openDropzone}>
                  <AttachFileIcon style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }} />
                </button>
              </Tooltip>
              {printChat && <Tooltip title="Print Chat">
                <IconButton onClick={handleDownloadTranscript}>
                  <PrintIcon style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }}/>
                </IconButton>
              </Tooltip>}
            </div>
          </div>
        </StyledEditorToolbar>
      );
  }
  if (chatBoxEditor) {
    return (
      <StyledEditorToolbar {...other}>
        <div id={id}>
          {' '}
          <div className="ql-formats">
            <Tooltip title="Bold">
              <button type="button" className="ql-bold" style={toolbarButtonStyle} />
            </Tooltip>
            <Tooltip title="Italic">
              <button type="button" className="ql-italic" style={toolbarButtonStyle} />
            </Tooltip>
            <Tooltip title="Underline">
              <button type="button" className="ql-underline" style={toolbarButtonStyle} />
            </Tooltip>
            <Tooltip title="Strikethrough">
              <button type="button" className="ql-strike" style={toolbarButtonStyle} />
            </Tooltip>
          </div>
          {attachFile && (
            <div className="ql-formats">
              <Tooltip title="Attach File">
                <button type="button" onClick={openDropzone}>
                  <AttachFileIcon style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }} />
                </button>
              </Tooltip>
            </div>
          )}
        </div>
      </StyledEditorToolbar>
    );
  }
  return (
    <StyledEditorToolbar {...other}>
      <div id={id}>
        {id !== 'ticket-reply' && <div className="ql-formats">
          <select className="ql-header" defaultValue="">
            {HEADINGS.map((heading, index) => (
              <option key={heading} value={index + 1}>
                {heading}
              </option>
            ))}
            <option value="">Normal</option>
          </select>
        </div>}

        <div className="ql-formats">
          <Tooltip title="Bold">
            <button type="button" className="ql-bold" />
          </Tooltip>
          <Tooltip title="Italic">
            <button type="button" className="ql-italic" />
          </Tooltip>
          <Tooltip title="Underline">
            <button type="button" className="ql-underline" />
          </Tooltip>
          <Tooltip title="Strikethrough">
            <button type="button" className="ql-strike" />
          </Tooltip>
        </div>

        {!isSimple && <div className="ql-formats">
          <select className="ql-color" />
          <select className="ql-background" />
        </div>}

        <div className="ql-formats">
          <Tooltip title="Number List">
            <button type="button" className="ql-list" value="ordered" />
          </Tooltip>
          <Tooltip title="Bullet List">
            <button type="button" className="ql-list" value="bullet" />
          </Tooltip>

          {!isSimple && <>
            <button type="button" className="ql-indent" value="-1" />
            <button type="button" className="ql-indent" value="+1" />
          </>}
        </div>

        {!isSimple && <div className="ql-formats">
          <button type="button" className="ql-script" value="super" />
          <button type="button" className="ql-script" value="sub" />
        </div>}

        {!isSimple && (
          <div className="ql-formats">
            <button type="button" className="ql-code-block" />
            <button type="button" className="ql-blockquote" />
          </div>
        )}

        {id !== 'ticket-reply' && (
          <div className="ql-formats">
            <button type="button" className="ql-direction" value="rtl" />
            <select className="ql-align" />
          </div>
        )}

        <div className="ql-formats">
          {!removeHyperLink && <Tooltip title="Link">
            <IconButton sx={{ p: 0, m: 0, ":focus": { color: "rgb(33, 43, 54) !important" } }} disableFocusRipple disableRipple onClick={() => setOpenCustomLinkSetter(val => !val)}>
              <Iconify icon={"mingcute:link-fill"} style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }} />
            </IconButton>
          </Tooltip>}
          <PopoutAddEmoji toolbarButtonStyle={toolbarButtonStyle} quillRef={quillRef} />       
          <Tooltip title="Image">
            <button type="button" className="ql-image" />
          </Tooltip>
        </div>

        <div className="ql-formats">
          {!isSimple && <button type="button" className="ql-formula" />}
          <Tooltip title="Remove Formatting">
            <button type="button" className="ql-clean" />
          </Tooltip>
        </div>

        {attachFile && (
          <div className="ql-formats">
            <Tooltip title="Attach File">
              <button type="button" onClick={openDropzone}>
                <AttachFileIcon />
              </button>
            </Tooltip>
          </div>
        )}

        {printChat && <div className="ql-formats">
          <Tooltip title="Print Chat">
            <IconButton onClick={handleDownloadTranscript}>
              <PrintIcon style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }}/>
            </IconButton>
          </Tooltip>
        </div>}
      </div>
    </StyledEditorToolbar>
  );
}
